
import { ReactNode } from "react";

interface NoteSectionProps {
  children: ReactNode;
}

const NoteSection = ({ children }: NoteSectionProps) => {
  return (
    <div className="bg-amber-50 p-2 rounded-lg my-2 text-amber-800 border border-amber-200">
      {children}
    </div>
  );
};

export default NoteSection;
